class PreserveScrollProducts extends HTMLElement {
    constructor() {
        super();
        // Promo tile markup as first rendered, before animations.js splits the heading
        // into words and toggles scroll-trigger classes (re-splitting on restore breaks it)
        this.promoHtmlCache = new WeakMap();
    }

    connectedCallback() {
        this.productGridUl = this.querySelector('#product-grid');
        this.productGridPagination = document.querySelector('#product-grid-pagination');
        const productGridObserver = new MutationObserver(() => {
            this.saveOnLoad();
        });

        productGridObserver.observe(this.productGridUl, { childList: true, subtree: true });


        // this.searchloadMoreBtn = document.querySelector('#product-grid-pagination .pagination__load-button.search-load-more');
        // if(this.searchloadMoreBtn){
        //     this.searchloadMoreBtn.addEventListener('click', this.saveOnLoad.bind(this));
        // }

        this.preserveScroll();
    }

    saveOnLoad() {
        // setTimeout(() => {
            const productGridHtml = this.productGridUl;

            // sessionStorage.setItem('productGridHtml', productGridHtml);
            // Select all the `.product-card` elements within `li` elements


            // Parse JSON from script[type=application/json] or legacy product-data attribute
            const parseCardJson =
                window.Shopify?.theme?.helpers?.parseProductCardElementData ||
                function (card) {
                    const scriptEl = card.querySelector(
                        'script[type="application/json"][data-product-card-json]'
                    );
                    if (scriptEl && scriptEl.textContent.trim()) {
                        try {
                            return JSON.parse(scriptEl.textContent);
                        } catch (e) {
                            console.error('Invalid JSON in product-card script', e);
                        }
                    }
                    const attr = card.getAttribute('product-data');
                    if (!attr) return null;
                    try {
                        return JSON.parse(attr);
                    } catch (err) {
                        console.error('Invalid JSON in product-data', err);
                        return null;
                    }
                };

            // Keep grid order, in-grid promo tiles included, so restore puts them back in place
            const productDataArray = Array.from(productGridHtml.children)
                .map((li) => {
                    if (li.classList.contains('grid__promo')) {
                        return { promo_html: this.getPromoHtml(li) };
                    }
                    const card = li.querySelector('product-card');
                    return card ? parseCardJson(card) : null;
                })
            .filter(parsed => parsed !== null); // Remove any failed JSON parses
            

            sessionStorage.setItem("productDataArray", JSON.stringify(productDataArray));

            sessionStorage.setItem('productGridPagination', this.productGridPagination.innerHTML);

            // const tagalysPaginationLinks = document.querySelector(".pagination-wrapper.tagalys-pagination-links");
            // const paginationStatusCaption =  document.querySelector(".pagination__status.caption");
            
            // if(tagalysPaginationLinks && paginationStatusCaption)
            // {
            //     sessionStorage.setItem("tagalysPaginationLinks", tagalysPaginationLinks.innerHTML);
            //     sessionStorage.setItem("paginationStatusCaption", paginationStatusCaption.innerHTML);
            // }
            
            
        // }, 2000);
    }

    getPromoHtml(li) {
        if (!this.promoHtmlCache.has(li)) {
            const clone = li.cloneNode(true);
            [clone, ...clone.querySelectorAll('.scroll-trigger')].forEach((el) => {
                el.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--onscreen', 'scroll-trigger--cancel');
            });
            // Height set by collection-promo-tiles.js, re-measured after restore
            clone.querySelectorAll('.grid__promo__inner').forEach((inner) => inner.removeAttribute('style'));
            this.promoHtmlCache.set(li, clone.outerHTML);
        }
        return this.promoHtmlCache.get(li);
    }


    preserveScroll() {
        try{
            //check if the secondlast visted pade is a product page
            const secondLastVisitedPage = sessionStorage.getItem('secondLastVisitedPage');
            const thirdLastVisitedPage = sessionStorage.getItem('thirdLastVisitedPage');

            if (secondLastVisitedPage && secondLastVisitedPage.includes('/products/') && thirdLastVisitedPage && thirdLastVisitedPage.split("&")[0] == window.location.href.split("&")[0]) {
                
                // const storedProductGridHtml = sessionStorage.getItem('productGridHtml');
                const productDataArrayStr = sessionStorage.getItem('productDataArray');
                const productDataArray = JSON.parse(productDataArrayStr);
                let productGridInnerHtml = "";
                if(productDataArray)
                {
                    productDataArray.forEach(element => {
                        if (element.promo_html) {
                            productGridInnerHtml = productGridInnerHtml + element.promo_html;
                            return;
                        }

                        const cardHtml = window.Shopify.theme.helpers.getProductCardMarkup(element, element.first_variant, "collection-list");
                        const liHtml = `<li id="prod_li_${element.handle}" class="grid__item scroll-trigger animate--slide-in"
                            data-cascade>` + cardHtml + `</li>`;
                        productGridInnerHtml = productGridInnerHtml + liHtml;
                    });   
                }

                this.productGridUl.innerHTML = productGridInnerHtml;




                if(window.location.href.includes("/search")) {
                    // const tagalysPaginationLinks = document.querySelector(".pagination-wrapper.tagalys-pagination-links");
                    // const paginationStatusCaption =  document.querySelector(".pagination__status.caption");
                    
                    
                    // const storedTagalysPaginationLinks = sessionStorage.getItem("tagalysPaginationLinks");
                    // const storedPaginationStatusCaption = sessionStorage.getItem("paginationStatusCaption");

                    // tagalysPaginationLinks.innerHTML = storedTagalysPaginationLinks;
                    // paginationStatusCaption.innerHTML = storedPaginationStatusCaption;
                    
                } 
                else {
                    const storedProductGridPagination = sessionStorage.getItem('productGridPagination');
                    if (this.productGridPagination && storedProductGridPagination) {
                        this.productGridPagination.innerHTML = storedProductGridPagination;
                    }
                }


                //extract product handle and  scroll into view
                let productHandle = secondLastVisitedPage.split('/products/')[1];
                productHandle = productHandle.split('/')[0];
                productHandle = productHandle.split('?')[0];

                const prodLiId = "prod_li_" + productHandle;
                const prodLi = document.querySelector('#' + prodLiId);
                if (prodLi) {
                    prodLi.scrollIntoView({ behavior: 'smooth', block: 'end' });
                } else {
                    console.warn('Product LI not found:', prodLiId);
                }

            }
            else {
                this.saveOnLoad();
            }
        }
        catch(e){
            console.log("An error occured while trying to preserve the scroll", e);
        }
    }

} 

customElements.define('preserved-scroll-products', PreserveScrollProducts);